export default function amountWithCurrency(amount, currency) {
  const normalizedCurrency = currency ? currency.toUpperCase() : currency;
  const currencySymbol = normalizedCurrency === 'USD' ? '$' : '€';
  const seperator = normalizedCurrency === 'USD' ? '.' : ',';
  return `${currencySymbol}${(amount).toFixed(2).replace('.', seperator)}`;
}
